import React from 'react';
import '../../styles/matchDaysStyles.css';
import { useTranslation } from "react-i18next";

export default function OpposingTeamBlock({team, home = true}) {
    const { t } = useTranslation();

	return (
            <div className='opposing-team-wrap'>
                <span>{team}</span>
                {home ? 
                (<span className='home-team-style'>{t('gamedays.match.home_team')}</span>) :
                (<span className='away-team-style'>{t('gamedays.match.away_team')}</span>)}
            </div>
		);
}